import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import ScheduleVisitPlanChartComponent from "../../../components/charts/xy/schedule-visitplan-chart.component";
import ToDoComplusoryChartComponent from "../../../components/charts/xy/todo-complusorytask-chart.component";
import paginationComponent from '../../../components/pagination/pagination.component';
import SelectSiteGroupComponent from '../../../components/site/select-site-group.component';
import SelectSiteComponent from '../../../components/site/select-site.component';
import languageModel from '../../../models/language.model';
import PerformanceModel from '../../../models/task-management/performance.model';
import ViewBase from '../../view-base.view';

export default function SalesPerformanceVisitStoreTaskView() {
  ViewBase.call(this);

  const VST_REPORT_WEEK = { id: 1, name: "Week" };
  const VST_REPORT_MONTH = { id: 2, name: "Month" };
  const VST_REPORT_CATEGORY = [VST_REPORT_WEEK, VST_REPORT_MONTH];

  const DEFAULT_FILTER_PARAMS = Object.freeze({
    fromPeriod: moment().subtract(5, 'months').format("YYYY-MM"),
    toPeriod: moment().format("YYYY-MM"),
    vstReportCategory: VST_REPORT_MONTH.id,
    PeriodType: VST_REPORT_MONTH.name,
    selectedSiteGroups: [],
    selectedSites: [],
    pageIndex: 1,
    pageSize: 10,
    totalSize: 0,
    totalCount: 0
  });

  let lstVisitPlan = [];
  let lstComplusoryTask = [];
  let lstSalePerformanceDetail = [];
  let inputFilter = _.cloneDeep(DEFAULT_FILTER_PARAMS);

  let events = {
    onStoreVisitChartDataChanged: (_data) => { },
    onComplusoryTaskChartDataChanged: (_data) => { }
  };

  let setDefaultValue = () => {
    lstSalePerformanceDetail = [];
    inputFilter = _.cloneDeep(DEFAULT_FILTER_PARAMS);

    onSearch();
  }

  let extractQueryParams = (filterParams) => {
    let result = {};

    result.pageSize = filterParams.pageSize;
    result.pageIndex = filterParams.pageIndex;

    if (inputFilter.vstReportCategory == VST_REPORT_MONTH.id) {
      result.fromPeriod = filterParams.fromPeriod.replace('-', '');
      result.toPeriod = filterParams.toPeriod.replace('-', '');
    } else if (inputFilter.vstReportCategory == VST_REPORT_WEEK.id) {
      result.fromPeriod = filterParams.fromPeriod.replace('-W', '');
      result.toPeriod = filterParams.toPeriod.replace('-W', '');
    }

    result.PeriodType = filterParams.PeriodType;
    result.SiteGroupID = filterParams.selectedSiteGroups.map(sg => sg.code).join('^');

    return result;
  }

  let getVisitPlanChartData = () => {
    this.showLoading();

    let queryParams = extractQueryParams(inputFilter);
    queryParams.SiteId = inputFilter.selectedSites.map(s => s.code).join('^');

    PerformanceModel.getScheduleVisitPlan(queryParams)
      .then((result) => {
        lstVisitPlan = result;
        if (lstVisitPlan)
          events.onStoreVisitChartDataChanged(lstVisitPlan);
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let getComplusoryTaskChartData = () => {
    this.showLoading();

    let queryParams = extractQueryParams(inputFilter);
    queryParams.siteCode = inputFilter.selectedSites.map(s => s.code).join('^');

    PerformanceModel.getToDoComplusoryTask(queryParams)
      .then((result) => {
        lstComplusoryTask = result;
        if (lstComplusoryTask)
          events.onComplusoryTaskChartDataChanged(lstComplusoryTask);
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let onSearch = () => {
    getVisitPlanChartData();
    getComplusoryTaskChartData();
    _search();
  }

  let _search = () => {
    this.showLoading();

    let queryParams = extractQueryParams(inputFilter);
    queryParams.SiteId = inputFilter.selectedSites.map(s => s.code).join('^');

    PerformanceModel.getScheduleStoreVisitTask(queryParams)
      .then((result) => {
        lstSalePerformanceDetail = result.data;
        inputFilter.totalCount = result.total;
        inputFilter.pageIndex = result.pageIndex;
        inputFilter.pageSize = result.pageSize;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputFilter.pageIndex = pageIndex;
    inputFilter.pageSize = pageSize;
    _search();
  }

  let onPageChanged = (pageIndex) => {
    inputFilter.pageIndex = pageIndex;
    _search();
  }

  let onClear = () => {
    setDefaultValue();
  }

  let _downloadExcel = () => {
    this.showLoading();
    var fileName = uuidv4();

    let queryParams = extractQueryParams(inputFilter);
    queryParams.SiteId = inputFilter.selectedSites.map(s => s.code).join('^');

    PerformanceModel.downloadVisitStoreExcel(queryParams, fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let selectVSTReportCategory = (e) => {
    if (inputFilter.vstReportCategory == e.target.dataset.id)
      return;

    inputFilter.vstReportCategory = e.target.dataset.id;

    if (inputFilter.vstReportCategory == VST_REPORT_MONTH.id) {
      inputFilter.fromPeriod = moment().subtract(5, 'months').format("YYYY-MM"); // 5 months ago (6 months of records)
      inputFilter.toPeriod = moment().format("YYYY-MM"); // Current month
    } else {
      let today = new Date();
      inputFilter.fromPeriod = getfirstweek(today, today.getMonth());
      inputFilter.toPeriod = getlastweek(today, today.getMonth());
      inputFilter.startMonth = today.getMonth();
      inputFilter.endMonth = today.getMonth();
    }

    inputFilter.PeriodType = VST_REPORT_CATEGORY[inputFilter.vstReportCategory - 1].name;
    onSearch();
  }

  let getlastweek = (d, monthInput) => {
    let monthenddate = new Date(d.getFullYear(), monthInput + 1, 0);
    var oneJan = new Date(monthenddate.getFullYear(), 0, 1);
    var wk = Math.ceil(((((monthenddate - oneJan) / 86400000) + (oneJan.getDay() + 6) % 7) + 1) / 7);
    if (((oneJan.getDay() + 6) % 7) > 3) wk--;

    if (wk > 0) {
      return monthenddate.getFullYear() + '-W' + (wk).toString().padStart(2, "0");
    }
  }

  let getfirstweek = (d, monthInput) => {
    let monthstartdate = new Date(d.getFullYear(), monthInput, 1);
    var oneJan = new Date(monthstartdate.getFullYear(), 0, 1);
    var wk = Math.ceil(((((monthstartdate - oneJan) / 86400000) + (oneJan.getDay() + 6) % 7) + 1) / 7);
    if (((oneJan.getDay() + 6) % 7) > 3) wk--;

    if (wk > 0) {
      return monthstartdate.getFullYear() + '-W' + (wk).toString().padStart(2, "0");
    } else {
      return getlastweek(new Date(monthstartdate.getFullYear() - 1, 11, 31), 11);
    }
  }

  let setStartWeekValue = (v) => {
    if (v.target.valueAsDate) {
      let monthInput = v.target.valueAsDate.getMonth();
      let monthState = inputFilter.startMonth;

      if (monthInput != monthState) {
        inputFilter.fromPeriod = getfirstweek(v.target.valueAsDate, monthInput);
        inputFilter.startMonth = monthInput;
      } else {
        inputFilter.fromPeriod = v.target.value;
        inputFilter.startMonth = v.target.valueAsDate.getMonth();
      }

    } else {
      inputFilter.fromPeriod = null;
      inputFilter.startMonth = null;
    }
  }

  let setEndWeekValue = (v) => {
    if (v.target.valueAsDate) {
      let monthInput = v.target.valueAsDate.getMonth();
      let monthState = inputFilter.endMonth;
      if (monthInput != monthState) {
        inputFilter.toPeriod = getlastweek(v.target.valueAsDate, monthInput);
        inputFilter.endMonth = monthInput;
      } else {
        inputFilter.toPeriod = v.target.value;
        inputFilter.endMonth = v.target.valueAsDate.getMonth();
      }
    } else {
      inputFilter.toPeriod = null;
      inputFilter.endMonth = null;
    }
  }

  return {
    oninit: (vnode) => {
      setDefaultValue();
    },
    view: (vnode) => {
      return [
        //Search
        m('.card.mb-3',
          m('.card-body',
            m('.row.g-4',
              m(".col-12.d-flex.gap-3.align-items-center.flex-wrap",
                VST_REPORT_CATEGORY.map(rc =>
                  m(".d-flex.justify-content-left.gap-2", [
                    m("input.form-check-input", {
                      type: "radio",
                      name: "btnRadioVSTReportCategory",
                      id: "btnRadioVSTReportCategory" + rc.id,
                      checked: (rc.id == inputFilter.vstReportCategory),
                      "data-id": rc.id,
                      onclick: selectVSTReportCategory,
                    }),
                    m("label.form-check-label", {
                      "for": "btnRadioVSTReportCategory" + rc.id,
                    },
                      rc.name
                    ),
                  ]),
                ),
              ),
              inputFilter.vstReportCategory == VST_REPORT_MONTH.id && [
                m(".col-sm-6.col-xl-3",
                  m("label.form-label", languageModel.getText("LT00000335", "Period From")),
                  m("input.form-control.form-control-bg",
                    {
                      "type": "month",
                      "value": inputFilter.fromPeriod,
                      onchange: (e) => { inputFilter.fromPeriod = e.target.value; }
                    }
                  ),
                ),
                m(".col-sm-6.col-xl-3",
                  m("label.form-label", languageModel.getText("LT00000336", "Period To")),
                  m("input.form-control.form-control-bg",
                    {
                      "type": "month",
                      "value": inputFilter.toPeriod,
                      onchange: (e) => { inputFilter.toPeriod = e.target.value; }
                    }
                  ),
                ),
              ],

              inputFilter.vstReportCategory == VST_REPORT_WEEK.id && [
                m(".col-sm-6.col-xl-3",
                  m("label.form-label", languageModel.getText("LT00000335", "Period From")),
                  m("input.form-control.form-control-bg",
                    {
                      "type": "week",
                      "value": inputFilter.fromPeriod,
                      oninput: (e) => {
                        inputFilter.fromPeriod = e.target.value;
                        setStartWeekValue(e);

                      },
                      onchange: (e) => { inputFilter.fromPeriod = e.target.value; }
                    }
                  ),
                ),
                m(".col-sm-6.col-xl-3",
                  m("label.form-label", languageModel.getText("LT00000336", "Period To")),
                  m("input.form-control.form-control-bg",
                    {
                      "type": "week",
                      "value": inputFilter.toPeriod,
                      oninput: (e) => {
                        inputFilter.toPeriod = e.target.value;
                        setEndWeekValue(e);

                      },
                      onchange: (e) => { inputFilter.toPeriod = e.target.value; }
                    }
                  ),
                ),
              ],

              m('.col-sm-6.col-xl-3',
                m('label.form-label', this.getText("LT00000072", "Site Group")),
                m(SelectSiteGroupComponent, {
                  selectedItems: inputFilter.selectedSiteGroups,
                  onChange: (g) => {
                    inputFilter.selectedSiteGroups = g;
                  }
                })
              ),

              m('.col-sm-6.col-xl-3',
                m('label.form-label', this.getText("LT00000071", "Site")),
                m(SelectSiteComponent, {
                  selectedItemList: inputFilter.selectedSites,
                  onChange: (s) => {
                    inputFilter.selectedSites = s;
                  }
                })
              ),
              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary', { onclick: onSearch }, languageModel.getText("LT00000001", "Search")),
                m('button.btn.btn-white', { onclick: onClear }, languageModel.getText("LT00000031", "Clear")),
              ),
            )
          )
        ),

        //Charts
        ((lstVisitPlan && lstVisitPlan.length > 0) || (lstComplusoryTask && lstComplusoryTask.length > 0)) && [
          m('.row.g-3.mb-3',
            m(".col-md-6",
              lstVisitPlan.length > 0 &&
              m('.card',
                m('.card-body.p-0',
                  m(ScheduleVisitPlanChartComponent,
                    { data: lstVisitPlan, events: events })
                )
              )
            ),
            m(".col-md-6",
              lstComplusoryTask.length > 0 &&
              m('.card',
                m('.card-body.p-0',
                  m(ToDoComplusoryChartComponent,
                    { data: lstComplusoryTask, events: events })
                )
              )
            )
          )],

        //List
        m('.card',
          m('.card-body',
            m('.d-flex.justify-content-end.mb-2',
              m('a.btn.btn-primary', { onclick: _downloadExcel },
                m('i.bi.bi-file-earmark-arrow-down-fill'), languageModel.getText("LT00000018", "Excel Download"),
              )
            ),
            m('.row',
              m(".col-12.p-0",
                m(".table-responsive",
                  m("table.table.table-bordered", [
                    m("thead.thead-bggrey",
                      m("tr.align-middle", [
                        m("th", { "scope": "col", "rowspan": "4" }, languageModel.getText("LT00000050", "User Name")),
                        m("th", { "scope": "col", "rowspan": "4" }, inputFilter.vstReportCategory == VST_REPORT_WEEK.id ? languageModel.getText("LT00000337", "Week") : languageModel.getText("LT00000326", "Month")),
                        m("th.text-center", { "scope": "col", "colspan": "4" }, languageModel.getText("LT00000338", "Store Visit")),
                        m("th.text-center", { "scope": "col", "colspan": "11" }, languageModel.getText("LT00000110", "Task")),
                      ]),
                      m("tr.text-center.light-header", { "class": "thead-bggrey align-middle " },
                        m("th", { "scope": "col", "rowspan": "3", "style": "white-space: normal;" }, languageModel.getText("LT00000339", "Target Visit Count")),
                        m("th", { "scope": "col", "rowspan": "3", "style": "white-space: normal;" }, languageModel.getText("LT00000340", "Actual Visit Count")),
                        m("th", { "scope": "col", "rowspan": "3", "style": "white-space: normal;" }, languageModel.getText("LT00000333", "Achievement")),
                        m("th", { "scope": "col", "rowspan": "3", "style": "white-space: normal;" }, languageModel.getText("LT00000341", "Unplanned Visit Count")),
                        m("th", { "scope": "col", "rowspan": "3" }, languageModel.getText("LT00000046", "Total")),
                        m("th.border-bottom-0", { "scope": "col", "colspan": "5" }, languageModel.getText("LT00000177", "Completed")),
                        m("th.border-bottom-0", { "scope": "col", "colspan": "5" }, languageModel.getText("LT00000342", "Incomplete")),
                      ),
                      m("tr.text-center.light-header", { "class": "thead-bggrey align-middle " },
                        m("th.border-top-transparent", { "scope": "col", "rowspan": "2" }),
                        m("th.border-bottom-0", { "scope": "col", "colspan": "2" }, languageModel.getText("LT00000115", "Mandatory")),
                        m("th.border-bottom-0", { "scope": "col", "colspan": "2" }, languageModel.getText("LT00000131", "Optional")),
                        m("th.border-top-transparent", { "scope": "col", "rowspan": "2" }),
                        m("th.border-bottom-0", { "scope": "col", "colspan": "2" }, languageModel.getText("LT00000115", "Mandatory")),
                        m("th.border-bottom-0", { "scope": "col", "colspan": "2" }, languageModel.getText("LT00000131", "Optional")),
                      ),
                      m("tr.text-center.light-header", { "class": "thead-bggrey align-middle " },
                        m("th.border-top-transparent", { "scope": "col" }),
                        m("th", { "scope": "col" }, "%"),
                        m("th.border-top-transparent", { "scope": "col" }),
                        m("th", { "scope": "col" }, "%"),
                        m("th.border-top-transparent", { "scope": "col" }),
                        m("th", { "scope": "col" }, "%"),
                        m("th.border-top-transparent", { "scope": "col" }),
                        m("th", { "scope": "col" }, "%"),
                      ),
                    ),
                    m("tbody",
                      lstSalePerformanceDetail.length == 0 &&
                      m("tr", { "class": "align-middle" },
                        m("td", { "colspan": "17" }, languageModel.getText("EM00000141", "No records found."))
                      ),

                      lstSalePerformanceDetail.map(pd => [
                        m("tr", [
                          m("td", pd.userName),
                          inputFilter.vstReportCategory == VST_REPORT_WEEK.id
                            ? m("td", moment(pd.period, 'YYYYWW').format('YYYY[W]WW'))
                            : m("td", pd.period),
                          m("td.text-end", pd.target.toLocaleString()),
                          m("td.text-end", pd.actual.toLocaleString()),
                          m("td.text-end", pd.visitRatio.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %'),
                          m("td.text-end", pd.unplanned.toLocaleString()),
                          m("td.text-end", pd.total.toLocaleString()),
                          m("td.text-end", pd.complete.toLocaleString()),
                          m("td.text-end", pd.completeMandatory.toLocaleString()),
                          m("td.text-end", pd.completeMandatoryRatio.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %'),
                          m("td.text-end", pd.completeOptional.toLocaleString()),
                          m("td.text-end", pd.completeOptionalRatio.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %'),
                          m("td.text-end", pd.notComplete.toLocaleString()),
                          m("td.text-end", pd.notCompleteMandatory.toLocaleString()),
                          m("td.text-end", pd.notCompleteMandatoryRatio.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %'),
                          m("td.text-end", pd.notCompleteOptional.toLocaleString()),
                          m("td.text-end", pd.notCompleteOptionalRatio.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %'),
                        ])
                      ]),
                    )
                  ])
                ),
                !this.isLoading && m(".px-3",
                  m(paginationComponent, { currentPage: inputFilter.pageIndex, pageSize: inputFilter.pageSize, totalItems: inputFilter.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}